module.exports = __webpack_public_path__ + "static/img/add-wenben.ea4c1fe2.png";